import { render } from "./event3.vue?vue&type=template&id=2a96acd0&scoped=true"
import script from "./event3.vue?vue&type=script&lang=js"
export * from "./event3.vue?vue&type=script&lang=js"

import "./event3.vue?vue&type=style&index=0&id=2a96acd0&lang=less&scoped=true"

import exportComponent from "D:\\myWorkspace\\CoreWeb\\MyNews\\ClientApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a96acd0"]])

export default __exports__